export const ExpandCircleUpIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.9L10.7 8.6L9.845 9.44L8 7.595L6.155 9.44L5.3 8.6L8 5.9ZM8 2C7.17 2 6.39 2.1575 5.66 2.4725C4.93 2.7875 4.295 3.215 3.755 3.755C3.215 4.295 2.7875 4.93 2.4725 5.66C2.1575 6.39 2 7.17 2 8C2 8.83 2.1575 9.61 2.4725 10.34C2.7875 11.07 3.215 11.705 3.755 12.245C4.295 12.785 4.93 13.2125 5.66 13.5275C6.39 13.8425 7.17 14 8 14C8.83 14 9.61 13.8425 10.34 13.5275C11.07 13.2125 11.705 12.785 12.245 12.245C12.785 11.705 13.2125 11.07 13.5275 10.34C13.8425 9.61 14 8.83 14 8C14 7.17 13.8425 6.39 13.5275 5.66C13.2125 4.93 12.785 4.295 12.245 3.755C11.705 3.215 11.07 2.7875 10.34 2.4725C9.61 2.1575 8.83 2 8 2Z"
        fill="var(--swapper-text-color)"
        fillOpacity="0.6"
      />
    </svg>
  );
};
